// Utilidades de Atención al Cliente: fechas en hora Argentina y formatos.
const TZ = 'America/Argentina/Buenos_Aires';

export const hoyArt = () => new Date().toLocaleDateString('en-CA', { timeZone: TZ });

export const sumarDias = (iso, n) => {
  const d = new Date(`${iso}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
};

export const finDeMes = (ym) => {
  const [y, m] = ym.split('-').map(Number);
  return new Date(Date.UTC(y, m, 0)).toISOString().slice(0, 10);
};

export const ultimosMeses = (n = 12) => {
  const [y, m] = hoyArt().split('-').map(Number);
  return Array.from({ length: n }, (_, i) => {
    const d = new Date(Date.UTC(y, m - 1 - i, 1));
    return d.toISOString().slice(0, 7);
  });
};

export const fmtFecha = (iso) => (iso ? iso.slice(0, 10).split('-').reverse().join('/') : '—');

export const fmtFechaHora = (isoUtc) => (isoUtc
  ? new Date(isoUtc).toLocaleString('es-AR', { timeZone: TZ, dateStyle: 'short', timeStyle: 'short' })
  : '—');

export const fmtHoras = (h) => {
  if (h === null || h === undefined) return '—';
  if (h < 1) return `${Math.round(h * 60)} min`;
  if (h < 48) return `${h.toFixed(1)} h`;
  return `${(h / 24).toFixed(1)} d`;
};

export const fmtPct = (v) => (v === null || v === undefined ? '—' : `${Number(v).toFixed(1)} %`);

export const CANAL_COLORES = {
  'WhatsApp (bot)': '#16a34a', Email: '#0284c7', 'Outbound Email': '#8b5cf6', Chat: '#f59e0b',
  Portal: '#e11d48', Phone: '#0d9488', 'Feedback Widget': '#a16207', 'Sin dato': '#94a3b8',
};
